import Lines from './lines.component';
export default Lines;
